__webpack_require__.p = "/hk/investment/funds/";